import { TractorFieldNames } from '@contracts/order/fields/TractorInformationFields';
import { PlateType } from '@contracts/order/valueNormalizers/PlateType';
import {
  BooleanField,
  DateField,
  DropdownField,
  PositiveIntegerField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class TractorLicenseEffectiveDateField extends DateField {
  public static fieldName: string =
    TractorFieldNames.TractorLicenseEffectiveDate;
}

export class TractorLicensePlateYearField extends PositiveIntegerField {
  public static fieldName: string = TractorFieldNames.TractorLicensePlateYear;
}

export class TractorLicensePlateTypeField extends DropdownField {
  public static fieldName: string = TractorFieldNames.TractorLicensePlateType;
  public static options = PlateType;
  public static validator = yup
    .string()
    .oneOf(TractorLicensePlateTypeField.options)
    .required();
}

export class TractorLicenseExpirationDateField extends DateField {
  public static fieldName: string =
    TractorFieldNames.TractorLicenseExpirationDate;
}

export class TractorLicenseIsApportionedPlateField extends BooleanField {
  public static fieldName: string =
    TractorFieldNames.TractorLicenseIsApportionedPlate;
}

export const tractorLicenseFields = {
  [TractorLicenseEffectiveDateField.fieldName]:
    TractorLicenseEffectiveDateField.validator,
  [TractorLicenseExpirationDateField.fieldName]:
    TractorLicenseExpirationDateField.validator,
  [TractorLicensePlateTypeField.fieldName]:
    TractorLicensePlateTypeField.validator,
  [TractorLicensePlateYearField.fieldName]:
    TractorLicensePlateYearField.validator,
  [TractorLicenseIsApportionedPlateField.fieldName]:
    TractorLicenseIsApportionedPlateField.validator,
};
